import { Component, inject, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  listRow,
  MenuOption,
} from '@standard-angular-utilities/shared-components';
import { UserDTO } from 'BaseDataTypes';
import { LogService } from 'BaseServices/log-service';
import { MainService } from 'BaseServices/main-service';
import { UserService } from 'BaseServices/user-service';
import {
  ClientSummaryDTO,
  ComponentSummaryDTO,
  FeatureSummaryDTO,
  JobIntervalDTO,
  JobIntervalTranslation,
  JobDetailDTO,
  JobSummaryDTO,
  JobStatusDTO,
  JobStatusTranslation,
  PlantSummaryDTO,
} from 'projects/Assets/src/assets-base/dataTypes';
import { JobDialogComponent } from 'projects/Assets/src/assets-base/Dialogs/job-dialog/job-dialog.component';
import { forkJoin } from 'rxjs';
import {
  BaseListPageComponent,
  multiSelectFilterList,
} from 'src/app/BasePages/base-list-page/base-list-page.component';

@Component({
  selector: 'app-job-view',
  imports: [BaseListPageComponent],
  templateUrl: './job-view.component.html',
  styleUrl: './job-view.component.css',
})
export class JobViewComponent {
  extraBurgerMenuOptions: MenuOption[] = [];
  headerList: string[] = [
    'Interval',
    'Interval værdi',
    'Beskrivelse',
    'Kunde',
    'Anlæg',
    'Komponent',
    'Oprettet af',
    'Ansvarlig',
    'Status',
    'Oprettelses Dato',
    'Udført dato',
  ];
  @ViewChild('baseListPage')
  baseListPage!: BaseListPageComponent<JobSummaryDTO>;
  readonly dialog = inject(MatDialog);
  logHeaderList: string[];

  multiSelectFilterLists: multiSelectFilterList[] = [];
  clients: ClientSummaryDTO[] = [];
  plants: PlantSummaryDTO[] = [];
  features: FeatureSummaryDTO[] = [];
  components: ComponentSummaryDTO[] = [];
  users: UserDTO[] = [];
  jobs: JobSummaryDTO[] = [];
  jobIntervals: any[] = [];
  jobStatus: any[] = [];
  constructor(
    private mainService: MainService,
    private userService: UserService,
    private logService: LogService
  ) {
    this.logHeaderList = this.logService.getLogHeaders('aftale'); // Lige nu ser den ud til at være lavet til specifikt timelog så vi skal tage en beslutning med det her
  }
  ngOnInit(): void {
    this.jobIntervals = Object.values(JobIntervalDTO)
      .filter((key) => isNaN(Number(key)))
      .map((value, index) => ({
        id: index,
        name: value.toString(),
      }));
    this.jobStatus = Object.values(JobStatusDTO)
      .filter((key) => isNaN(Number(key)))
      .map((value, index) => ({
        id: index,
        name: value.toString(),
      }));
  }
  ngAfterViewInit(): void {
    this.updateListAgreements();
  }
  updateMultiSelectFilterLists() {
    var list = [];

    var intervalList: multiSelectFilterList = {
      Items: this.jobIntervals,
      selectedItemsIds: this.jobIntervals.map((item, index) => index),
      placeHolderText: 'Vælg Interval',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (job: JobSummaryDTO) {
        const keys = Object.keys(JobIntervalDTO).filter((key) =>
          isNaN(Number(key))
        );
        const value = job.interval;
        const index = keys.indexOf(value.toString());
        return this.selectedItemsIds.includes(index);
      },
      HideWithHeaderIndex: 0,
    };
    list.push(intervalList);

    var clientList: multiSelectFilterList = {
      Items: this.clients,
      selectedItemsIds: this.clients.map((c) => c.id),
      placeHolderText: 'Vælg Kunde',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (job: JobSummaryDTO) {
        if (!job) return false;
        if (!job.clientName) return false;
        const match = this.Items.find((i: any) => i.name === job.clientName);
        return match ? this.selectedItemsIds.includes(match.id) : false;
      },
      HideWithHeaderIndex: 3,
    };
    list.push(clientList);

    var statusList: multiSelectFilterList = {
      Items: this.jobStatus,
      selectedItemsIds: this.jobStatus.map((item, index) => index),
      placeHolderText: 'Vælg Status',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (job: JobSummaryDTO) {
        const keys = Object.keys(JobStatusDTO).filter((key) =>
          isNaN(Number(key))
        );
        const value = job.status;
        const index = keys.indexOf(value.toString());
        return this.selectedItemsIds.includes(index);
      },
      HideWithHeaderIndex: 10,
    };
    list.push(statusList);

    var createdByList: multiSelectFilterList = {
      Items: this.users,
      selectedItemsIds: this.users.map((c) => c.id),
      placeHolderText: 'Vælg udvikler',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (job: JobSummaryDTO) {
        if (!job) return false;
        if (!job.createdByName) return false;
        const match = this.Items.find((i: any) => i.name === job.createdByName);
        return match ? this.selectedItemsIds.includes(match.id) : false;
      },
      HideWithHeaderIndex: 6,
    };
    list.push(createdByList);

    var responsibleList: multiSelectFilterList = {
      Items: this.users,
      selectedItemsIds: this.users.map((c) => c.id),
      placeHolderText: 'Vælg Ansvarlig',
      selectedValueChange: function (event) {
        this.selectedItemsIds = event;
      },
      filterFunction: function (job: JobSummaryDTO) {
        if (!job) return false;
        if (!job.responsibleName) return false;
        const match = this.Items.find((i: any) => i.name === job.responsibleName);
        return match ? this.selectedItemsIds.includes(match.id) : false;
      },
      HideWithHeaderIndex: 7,
    };
    list.push(responsibleList);

    this.multiSelectFilterLists = list;
  }

  agreementClicked = (job?: JobSummaryDTO) => {
    var today = new Date();
    var jobRequest: JobDetailDTO;

    const clientId = job?.clientName
      ? this.clients.find((c) => c.name === job.clientName)?.id ?? 0
      : 0;
    const plantId = job?.plantName
      ? this.plants.find((p) => p.plantName === job.plantName)?.id ?? null
      : null;
    const componentId = job?.componentName
      ? this.components.find((c) => c.typeNumber === job.componentName)?.id ?? null
      : null;
    const createdById = job?.createdByName
      ? this.users.find((u) => u.name === job.createdByName)?.id ?? 0
      : 0;
    const responsibleId = job?.responsibleName
      ? this.users.find((u) => u.name === job.responsibleName)?.id ?? 0
      : 0;

    jobRequest = {
      id: job?.id ?? 0,
      interval: (JobIntervalDTO as any)[job?.interval ?? JobIntervalDTO.Daily],
      intervalValue: job?.intervalValue ?? 0,
      created: job?.created ?? today,
      createdById: createdById,
      responsibleId: responsibleId,
      completed: job?.completed,
      description: job?.description,
      status: (JobStatusDTO as any)[job?.status ?? JobStatusDTO.Open],
      clientId: clientId,
      plantId: plantId ?? null,
      componentId: componentId ?? null,
    };

    let dialogRef = this.dialog.open(JobDialogComponent, {
      data: { data: [jobRequest] },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        this.updateListAgreements();
      }
    });
  };

  switchDataInList() {
    // TODO få til at ligne den i courseParticipant componetn
  }

  updateListAgreements() {
    forkJoin({
      clients: this.mainService.getAll<ClientSummaryDTO>('Client'),
      plants: this.mainService.getAll<PlantSummaryDTO>('Plant'),
      features: this.mainService.getAll<FeatureSummaryDTO>('Feature'),
      components: this.mainService.getAll<ComponentSummaryDTO>('Component'),
      jobs: this.mainService.getAll<JobSummaryDTO>('Job'),
      users: this.userService.getUserDTOs(),
    }).subscribe(({ clients, plants, features, components, jobs, users }) => {
      this.clients = clients;
      this.plants = plants;
      this.features = features;
      this.components = components;
      this.jobs = jobs;
      this.users = users;
      this.updateMultiSelectFilterLists();

      let listData: listRow<JobSummaryDTO>[] = [];
      jobs.forEach((job) => {
        listData.push({
          object: job,
          id: job.id,
          data: [
            JobIntervalTranslation[job.interval],
            job.intervalValue.toString(),
            job.description ?? '',
            job.clientName ?? '',
            job.plantName ?? '',
            job.componentName ?? '',
            job.createdByName ?? '',
            job.responsibleName ?? '',
            JobStatusTranslation[job.status],
            new Date(job.created),
            job.completed ? new Date(job.completed) : '',
          ],
        });
      });
      this.baseListPage.UpdateListData(listData);
    });
  }
}
